import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../models/list-result';
import { WorkflowCategoryV1Read } from '../models/workflow-category-v1-read';

@Injectable({
    providedIn: 'root',
})
export class WorkflowCategoriesV1Service {
    private readonly baseUrl = '/api/module_manager/v1/public/workflowcategories';
    private readonly headers = { 'Content-Type': 'application/query.api+json' };

    constructor(private http: HttpClient) {}

    getCategories(): Observable<ListResult<WorkflowCategoryV1Read>> {
        return this.http.get<ListResult<WorkflowCategoryV1Read>>(this.baseUrl, { headers: this.headers });
    }
}
